import React from "react";
import { Row, Col, FormGroup } from "react-bootstrap";
import InputError from "app/Components/_form/InputError/InputError";
import SimpleSelect from "app/Components/SearchableSelect/SimpleSelect";
import Label from "app/Components/_form/Label/Label";
import { useTraining } from "app/_helpers/hooks";
import { employeeFormLabel, employeeTrainingEligibilityList } from "../Constant";
import DatePicker from "app/Components/DateTimeCustom/CustomDateTime";
function EmployeeTrainingHistoryForm({ form = {}, onChange, error = {}, siteList }) {
  const [, trainingOption] = useTraining("filter[type]=training");
  console.log("/*/*/*/*/*/history FOmr", form);
  return (


    <>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Label>{employeeFormLabel["trainingDesignation"]}</Label>

            <SimpleSelect
              name={"newBasicTrainingDesignation"}
              value={+form?.newBasicTrainingDesignation}
              onChange={onChange}
              options={trainingOption}
              placeHolder={employeeFormLabel["trainingDesignation"]}
              menuPortalTarget={null}
            />
            <InputError error={error["newBasicTrainingDesignation"]} />
          </FormGroup>
        </Col>

      </Row>
      <Row>

        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["trainingEligibility"]}</Label>

            <SimpleSelect
              name={"newTrainingEligibility"}
              value={form?.newTrainingEligibility}
              options={employeeTrainingEligibilityList}
              onChange={onChange}
              placeHolder={employeeFormLabel["trainingEligibility"]}
              label={"name"}
              id="value"
              menuPortalTarget={null}
            />
            <InputError error={error["newTrainingEligibility"]} />
          </FormGroup>
        </Col>


        <Col md={4}>
          <FormGroup>
            <Label>{employeeFormLabel["effectiveDate"]}</Label>

            <DatePicker
              name={"effectiveDate"}
              value={form?.effectiveDate}
              onChangeDate={onChange}
              label={employeeFormLabel["effectiveDate"]}
              placeHolder={employeeFormLabel["effectiveDate"]}
              error={error["effectiveDate"]}
            />
            <InputError error={error["effectiveDate"]} />
          </FormGroup>
        </Col>

      </Row>
    </>
  );
}

export default EmployeeTrainingHistoryForm;
